import React from "react";
import { type CommercialFlightEditProps, type PrivateFlightEditProps } from "../../model";
import CommercialFlightEdit from "./commercialflightedit";
import PrivateJetEdit from "./privatejetedit";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";

interface Props {
  // TODO: initial segment
  index: number

  type: server.dto.FlightTypes
  onTypeChanged: (newType: server.dto.FlightTypes, index: number) => void

  editedSegment: CommercialFlightEditProps & PrivateFlightEditProps
  onSegmentEdited: (segment: CommercialFlightEditProps & PrivateFlightEditProps, index: number) => void

  frequentFlyerPrograms: server.dto.FrequentFlyerProgram[]

  noDepartureAirportError: boolean
  noArrivalAirportError: boolean
  noAirlineError: boolean
  noFlightCodeError: boolean
  noFlightNumberError: boolean
  departureTooEarly: boolean
}

export default class SegmentEdit extends React.Component<Props> {
  onSegmentChange = (editedSegment: CommercialFlightEditProps & PrivateFlightEditProps) => {
    const newSegment: CommercialFlightEditProps & PrivateFlightEditProps = { ...this.props.editedSegment, ...editedSegment };
    this.props.onSegmentEdited(newSegment, this.props.index);
  };

  public render(): JSX.Element {
    const commercialType: server.dto.FlightTypes = "commercial";
    const privateType: server.dto.FlightTypes = "private";

    let flightEdit;

    if (this.props.type === "commercial") {
      flightEdit = <CommercialFlightEdit
        frequentFlyerPrograms={this.props.frequentFlyerPrograms}
        segment={this.props.editedSegment}
        onSegmentChange={this.onSegmentChange}
        noDepartureAirportError={this.props.noDepartureAirportError}
        noArrivalAirportError={this.props.noArrivalAirportError}
        noAirlineError={this.props.noAirlineError}
        noFlightCodeError={this.props.noFlightCodeError}
        noFlightNumberError={this.props.noFlightNumberError}
        departureTooEarly={this.props.departureTooEarly}
      />;
    } else {
      flightEdit = <PrivateJetEdit
        segment={this.props.editedSegment}
        onSegmentChange={this.onSegmentChange}
        noDepartureAirportError={this.props.noDepartureAirportError}
        noArrivalAirportError={this.props.noArrivalAirportError}
        departureTooEarly={this.props.departureTooEarly}
      />;
    }

    return <>
      <div className="flex padding align-center">
        <div className="margin-right">
          {RESX.GeneralLabels.Type}:
        </div>
        <RadioGroup
          orientation="horizontal"
          options={[
            { label: RESX.Flight.CommercialFlight, value: commercialType },
            { label: RESX.Flight.PrivateJet, value: privateType }
          ]}
          value={this.props.type}
          onChange={(newType) => { this.props.onTypeChanged(newType as server.dto.FlightTypes, this.props.index); }}
        />
      </div>
      {flightEdit}
    </>;
  }
}
